export default __webpack_public_path__ + "static/media/J720_21M720H.991645d4.STEP";